import {
  inputClassNames,
  labelClassNames,
  StandardInput,
  ValidatedInput,
} from "components/forms/input";
import { TextEditor } from "components/text-editor/text-editor";
import { EditorState } from "draft-js";
import { UseInputReturn } from "lib/hooks/use-input";

interface Props {
  title: UseInputReturn<string>;
  description: UseInputReturn<EditorState>;
  isActive: UseInputReturn<boolean>;
  image: UseInputReturn<string>;
  price: UseInputReturn<number>;
  note: UseInputReturn<string>;
  disablePrice?: boolean;
}

export const BaseSubscriptionInputs = ({
  description,
  image,
  isActive,
  title,
  price,
  note,
}: Props) => {
  return (
    <>
      <StandardInput
        type='text'
        name='title'
        id='title'
        label='Title'
        bind={{ ...title.bind }}
      />
      <StandardInput
        type='url'
        name='image'
        id='image'
        label='Image'
        bind={{ ...image.bind }}
      />

      <label htmlFor='isActive' className={`${labelClassNames} flex flex-col`}>
        Is Active
        <input
          checked={isActive.value}
          onChange={(e) => isActive.setValue(e.target.checked)}
          type='checkbox'
          name='isActive'
          id='isActive'
          className={`h-8 w-8 mt-1 rounded-md text-green-default`}
        />
      </label>

      <div>
        <ValidatedInput
          type='number'
          name='price'
          id='price'
          label='Price'
          bind={{ ...price.bind }}
          showError={!price.isValid}
        />

        <p className='text-gray-400 pl-2 pt-px text-sm'>
          Modifying the subscription price will change it for all new subs.{" "}
          <em>Existing subs will keep the same price as before</em>
        </p>
      </div>

      <label className={`${labelClassNames} flex flex-col`}>
        Note (internal use only)
        <textarea
          className={`${inputClassNames}`}
          value={note.value}
          onChange={(e) => note.setValue(e.target.value)}
        />
      </label>

      <label
        htmlFor='description'
        className={`w-full col-span-full ${labelClassNames}`}>
        Description (Please don't edit this text!)
        <TextEditor state={description.value} setState={description.setValue} />
      </label>
    </>
  );
};
